// eslint-disable-next-line import/extensions
import { hideableLayoutContextMenuItems, hideableLayoutFunc } from './hideable-layout.js';

const minorValuesConfig = {
	tagName: 'HideableLayout',
	key: 'minorValuesHideableLayout',
	contextMenuItems: hideableLayoutContextMenuItems,
	func: hideableLayoutFunc,
	title: { desc: 'Sankey13', name: 'Minor values' },
	children: [
		{
			tagName: 'VerticalLayout',
			children: [
				{
					tagName: 'Radio',
					key: 'minorValuesGroupNodes',
					horizontal: true,
					className: 'toggle-button-radio _2item',
					options: [
						{ name: { desc: 'Sankey14', name: 'Nodes' }, value: 'nodes' },
						{ name: { desc: 'Sankey50', name: 'Flows' }, value: 'flows' }
					],
					useButtons: true,
					trueKey: 0
				},
				{
					tagName: 'Checkbox',
					key: 'minorValuesIsHidingEnabled',
					checked: false,
					text: { desc: 'Sankey51', name: 'Hide values smaller than' }
				},
				{
					tagName: 'HorizontalLayout',
					className: 'horizontal-flex-space-between _2item-stretch',
					children: [
						{
							tagName: 'Text',
							text: '<'
						},
						{
							tagName: 'InputNumber',
							key: 'minorValuesHideThreshold',
							showStepper: false,
							applyChangeOnFocusOut: false,
							min: 0
						}
					]
				},
				{
					tagName: 'Checkbox',
					key: 'minorValuesIsGroupEnabled',
					checked: false,
					text: { desc: 'Sankey52', name: 'Group' }
				},
				{
					tagName: 'HorizontalLayout',
					className: 'horizontal-flex-space-between _2item-stretch',
					children: [
						{
							tagName: 'Text',
							text: { desc: 'Sankey53', name: 'Label' }
						},
						{
							tagName: 'Input',
							key: 'minorValuesGroupLabel',
							applyChangeOnFocusOut: true
						}
					]
				},
				{
					tagName: 'Text',
					text: { desc: 'Sankey59', name: 'Values cannot overlap' },
					key: 'overlapWarning',
					className: 'sankey-viz-overlap__warning'
				},
				{
					tagName: 'HorizontalLayout',
					className: 'horizontal-flex-space-between _2item-stretch',
					children: [
						{
							tagName: 'Text',
							text: { desc: 'Sankey54', name: 'From' }
						},
						{
							tagName: 'InputNumber',
							key: 'minorValuesGroupFrom',
							showStepper: false,
							applyChangeOnFocusOut: false
						}
					]
				},
				{
					tagName: 'HorizontalLayout',
					className: 'horizontal-flex-space-between _2item-stretch',
					children: [
						{
							tagName: 'Text',
							text: { desc: 'Sankey55', name: 'To' }
						},
						{
							tagName: 'InputNumber',
							key: 'minorValuesGroupTo',
							showStepper: false,
							applyChangeOnFocusOut: false
						}
					]
				}
			]
		}
	]
};

export default minorValuesConfig;
